export default "__VITE_ASSET__274b30e2__"